<section class="py-5 bg-primary text-primary-foreground home-sections">
  <div class="container container-max">
    <ul class="breadcrumbs">
      <li class="text-primary-foreground opacity-60p"><a [routerLink]="''">Home</a></li>
      <li class="text-primary-foreground">Contact Us</li>
    </ul>
  </div>

  <div class="container container-max pt-3 pb-2">
    <h1 class="fs-40 fw-bold heading-font text-uppercase">Get In Touch</h1>
    <p class="mt-3 line-height-180p fs-15" style="max-width: 800px"><span class="opacity-70p">Note that if you want to contact us with regards to reporting discrepancies found or BOR or PSC records within this portal, kindly make use of</span>&nbsp;<a class="text-decoration-underline opacity-90p" [routerLink]="'/report-psc'">this form here instead</a>.</p>
  </div>
</section>
<div class="pt-5 pb-4"></div>
<bor-contacts-section [isPage]="true" />
